/**
 * Created by Jerker Nord on 2018-12-10.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ThorGameAssets} from "../../ThorGameAssets";

export class ThorReelsFrame extends BaseView {

    private _layer:ScalableLayer;
    private _reelsFrame:PIXI.Sprite;

    private static YPOS_OFFSET:number = -30;
    private static XPOS_OFFSET:number = -3;
    public static thorReelsFrame:ThorReelsFrame;

    constructor(resourcesGroup:ResourcesGroupName) {
        super(resourcesGroup);
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.REELS_FRAME.name);
        this._layer.addChild(this);
        ThorReelsFrame.thorReelsFrame = this;
    }

    protected initAnimations():void {
        this._reelsFrame = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.REELS_FRAME)[0]);
        this._reelsFrame.anchor.set(0.5, 0.5);
        this._reelsFrame.position.x = ThorGameConfig.instance.GAME_WIDTH / 2 + ThorReelsFrame.XPOS_OFFSET;
        this._reelsFrame.position.y = (ThorGameConfig.instance.GAME_HEIGHT / 2) + ThorReelsFrame.YPOS_OFFSET;
        this.addChild(this._reelsFrame);
    }
}